// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useRef} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import Icon_close from '../../../img/icons/16/close.svg';
import {www_hola} from 'hola_opt';
import {use_click_outside} from '../../../../../hola/pub/lib/use_click_outside';

import styles from './plan_table_popup.module.less';

interface i_plan_table_popup_props {
    cls?: string;
    icon?: JSX.Element;
    title: string | JSX.Element;
    text?: string | JSX.Element;
    cta?: JSX.Element;
    type?: 'success' | 'warning' | 'empty';
    reason?: 'expire' | 'cancelled' | 'failed' | 'expired' | 'bandwidth';
    on_close?: ()=>void;
    cancelled_renewal_cls?: string;
    stop_propagation?: boolean;
    icon_class?: string;
}
export const Plan_table_popup = (props: i_plan_table_popup_props)=>{
    const {cls, icon, title, text, cta, type = 'warning', reason, icon_class,
        on_close, cancelled_renewal_cls, stop_propagation=false} = props;
    const {theme} = useContext(Settings_context);
    const popup_ref = useRef(null);
    const is_toolip = www_hola.site == 'toolip';
    const font_sizes = {
      toolip: {title: theme.p14, text: theme.p12},
      default: {title: theme.p16, text: theme.p14},
    };
    const font_size = font_sizes[is_toolip && reason != 'bandwidth' ?
        'toolip' : 'default'];
    const icon_cls = cn(
        styles.mb16,
        reason == 'cancelled' || reason == 'expired' ?
            cn(styles.cancelled_renewal, cancelled_renewal_cls) :
            styles[`${type}_icon`],
        icon_class && icon_class
    );
    use_click_outside(popup_ref, on_close);
    return <div ref={popup_ref} className={cn(styles.plan_table_popup, cls,
      is_toolip && styles.plan_table_popup_toolip)}
      onClick={e=>e.stopPropagation()}
      {...(stop_propagation && {onMouseOver: e=>e.stopPropagation()})}
      tabIndex={-1}>
      {on_close && <div className={styles.plan_table_popup_close}
        onClick={on_close}><Icon_close/></div>}
      {icon && <div className={icon_cls}>{icon}</div>}
      <p className={cn(font_size.title, theme[is_toolip ? 'med' : 'bold'],
        theme.color_n700, styles.mb8)}>{title}</p>
      <p className={cn(font_size.text, {
        [styles.mb24]: reason != 'bandwidth',
        [styles.mb16]: reason == 'bandwidth' && is_toolip,
      })}>{text}</p>
      {cta}
    </div>;
};
